module.exports = __webpack_public_path__ + "img/animals_01_H.70e22c3e.jpg";